export function makeNegative(num: number): number {
  return num > 0 ? -num : num;
}
